const resolveProtocol = (url: string | undefined): string | undefined => {
  if (typeof window !== "undefined" && window.location.protocol === "http:") {
    return url?.replace("https", "http");
  }
  return url;
};

export const Config = {
  BASE_URL: resolveProtocol(process.env.REACT_APP_Base_URL),
  NAMAZ_BASE_URL: process.env.REACT_APP_Namaz_URL,
  IMAGE_BASE_URL: process.env.REACT_APP_Image_URL,
  TIMEOUT: 30000,
  BASIC_AUTH_USERNAME: process.env.REACT_APP_UserName_Basic,
  BASIC_AUTH_PASSWORD: "6*C$q&3cd",
  TOKEN_USERNAME: process.env.REACT_APP_UserName,
  TOKEN_PASSWORD: process.env.REACT_APP_Password,
  recaptchaSiteKey: "6LcbPUstAAAAAGEvt_ilr5CFnR8fPXlRf9P8sRhJ",
} as const;
